import { render } from "./closeButton.vue?vue&type=template&id=df8c70d0&ts=true"
import script from "./closeButton.ts?vue&type=script&lang=ts"
export * from "./closeButton.ts?vue&type=script&lang=ts"

import "./closeButton.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__